import React from "react";
import { motion } from "framer-motion";
import { Calendar, ArrowRight, Clock, MapPin } from "lucide-react";
import NoImage from "../../../assets/images/No_Image_Available.jpg";
import DateFormatterComponent from "../../../utils/DateFormatterComponent";

const ProgrammeCardRedesign = ({ programme, index, handleClick, fadeInUp }) => {
  return (
    <motion.div
      variants={fadeInUp}
      whileHover={{ y: -12 }}
      onClick={() => handleClick(programme.slug)}
      className="group relative bg-gradient-to-br from-white to-slate-50 rounded-3xl overflow-hidden border-2 border-mamba-sky-blue/20 hover:border-mamba-golden transition-all duration-500 hover:shadow-2xl cursor-pointer"
    >
      {/* Image */}
      <div className="relative h-72 overflow-hidden">
        <motion.img
          whileHover={{ scale: 1.1 }}
          transition={{ duration: 0.6 }}
          src={
            programme.display_image_url ||
            NoImage
          }
          alt={programme.name}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/50 to-transparent" />

        {/* Floating stats on image */}
        <div className="absolute bottom-4 left-4 right-4 flex gap-2">
          {programme.duration && (
            <div className="px-3 py-2 bg-white/90 backdrop-blur-sm rounded-lg text-xs font-bold text-slate-900">
              {programme.duration} {programme.duration_units}
            </div>
          )}
          {programme.total_adventures && (
            <div className="px-3 py-2 bg-mamba-sky-blue/90 backdrop-blur-sm rounded-lg text-xs font-bold text-white">
              {programme.total_adventures} Adventures
            </div>
          )}
        </div>
      </div>

      {/* Content - Mamba Hikers Theme */}
      <div className="p-6">
        <h3 className="text-2xl font-montserrat font-black text-mamba-navy mb-3 leading-tight group-hover:text-mamba-sky-blue transition-colors">
          {programme.name}
        </h3>
        <p className="text-sm text-slate-600 leading-relaxed mb-4 line-clamp-3 font-inter">
          {programme.description}
        </p>

        {/* Stats row - Mamba Theme */}
        <div className="flex items-center justify-between pt-4 border-t border-mamba-sky-blue/20">
          {programme.price && (
            <div>
              <div className="text-xs text-slate-500 mb-1">
                From
              </div>
              <div className="text-xl font-montserrat font-black text-mamba-navy">
                KSh {(programme.price / 1000).toFixed(0)}K
              </div>
            </div>
          )}
          <div className="flex items-center gap-2 text-mamba-sky-blue font-semibold text-sm group-hover:gap-3 transition-all">
            Explore
            <ArrowRight className="w-4 h-4" />
          </div>
        </div>
      </div>

      {/* Accent gradient at bottom - Mamba Theme */}
      <div className="h-1 bg-gradient-to-r from-mamba-golden to-mamba-sky-blue transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />
    </motion.div>
  );
};

export default ProgrammeCardRedesign;
